import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { HomePage } from '../home/home';
import { CommonProvider } from '../../providers/common/common';

/**
 * Generated class for the LeadThankYouPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-lead-thank-you',
  templateUrl: 'lead-thank-you.html',
})
export class LeadThankYouPage {
  totalAmount1=0;
  totalAmount=0;
  sentionAmount=0;
  tanure=10;
  roi='9%';
  constructor(public navCtrl: NavController, public navParams: NavParams,public loadingCtrl: LoadingController,private cp: CommonProvider) {
  }

  ionViewDidLoad() {
     
    // this.veiwLead(JSON.parse(this.navParams.data).Payload.lead.leadid);
  }
  // veiwLead(leadid){
     
  //   let request:any = {};
  //     //console.log(leadid)
  //     request.leadId=leadid;
  //     let loading = this.loadingCtrl.create({
  //          content: 'Please wait...'
  //         });
  //     loading.present();
  //     this.cp.viewLeadById(loading,request).then((res:any)=>{
  //        loading.dismiss();
  //        try{
  //         console.log(JSON.parse(res).Payload.lead.applicants);
  //         const applicants=JSON.parse(res).Payload.lead.applicants;
  //         var totalIncm=0; 
  //         var existingPayEmai=0;
  //         applicants.forEach((resp:any)=>{

  //           totalIncm=parseInt(totalIncm)+parseInt(resp.ibhfl_averageprofititr)+parseInt(resp.ibhfl_monthlyfixedincome)+parseInt(resp.ibhfl_monthlyvariableincome)+parseInt(resp.ibhfl_othernonbusinessincome)+parseInt(resp.ibhfl_averagegrossreceipts)+ parseInt(resp.ibhfl_rental)+parseInt(resp.ibhfl_agri)+ parseInt(resp.ibhfl_divinterest); 
  //           existingPayEmai=parseInt(existingPayEmai+parseInt(resp.ibhfl_totalmonthlyfixedemi));
  //           console.log(totalIncm,existingPayEmai);
  //         });
  //          console.log(totalIncm,existingPayEmai,"tets"); 
  //          this.totalAmount1=(parseInt(totalIncm)*0.5)-parseInt(existingPayEmai);
  //          console.log(this.totalAmount1,"totalAmount1");
  //          this.totalAmount=this.calculatePMT(9/100/12,(parseInt(JSON.parse(res).Payload.lead.ibhfl_loantenure)*12),-1,0,0);
  //          console.log(this.totalAmount,"totalAmount");
           
  //          this.sentionAmount=this.totalAmount1/this.totalAmount;
  //          this.sentionAmount=this.roundToNearest(Math.round(this.sentionAmount.toFixed(2)))
  //          console.log(this.sentionAmount,"sentionAmount");

  //          this.tanure=parseInt(JSON.parse(res).Payload.lead.ibhfl_loantenure);

  //        }catch(e){
  //         //console.log(e)
  //        }
  //      })
  // }
  // roundToNearest(value) { 
  //     const order = Math.pow(10, Math.floor(Math.log10(value)) - 1); 
  //     const nearest = Math.round(value / order) * order; 
  //     return this.numberFormatter(nearest); 
  // } 
  // numberFormatter(x) {
  //   if(!x){
  //     return
  //   }else{
  //       x = x.toString();
  //       var afterPoint = '';
  //       if (x.indexOf('.') > 0)
  //           afterPoint = x.substring(x.indexOf('.'), x.length);
  //       x = Math.floor(x);
  //       x = x.toString();
  //       var lastThree = x.substring(x.length - 3);
  //       var otherNumbers = x.substring(0, x.length - 3);
  //       if (otherNumbers != '')
  //           lastThree = ',' + lastThree;
  //       var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
  //       return res;
  //     }  
  // }
  gotoHome()
  {
  this.navCtrl.setRoot(HomePage)
  }
   // calculatePMT(rate,nper,pv,fv,type)
   //  {
   //      if(rate==0)
   //      {
   //          return-pv/nper;
   //      }
   //      else
   //      {  
   //          var pvif=Math.pow(1+rate,nper);
   //          var fvifa=(Math.pow(1+rate,nper)-1)/rate;
   //          var type1=(type!=0)?1:0;
   //          var calPMT=((-pv*pvif-fv)/((1+rate*type1)*fvifa));
   //          console.log(calPMT,"calPMT");
   //          return calPMT;
   //      }
   //  }
}



// WEBPACK FOOTER //
// ./src/pages/lead-thank-you/lead-thank-you.ts